import _ from 'lodash';
import i18n from "i18n";

export const types = {
  text: 'Text',
  number: 'Number',
  date: 'Date',
  singleChoice: 'SingleChoice',
  multiChoice: 'multiChoice',
  singleChoiceButton: 'singleChoiceButton'
};

const isEmptyOrBlank = (value) => {
  // Check for null, undefined, or NaN
  if (_.overSome([_.isNil, _.isNaN])(value)) return true;

  // Numbers, booleans, and dates are valid (not empty)
  if (_.overSome([_.isNumber, _.isBoolean, _.isDate])(value)) return false;

  // Check for empty strings (including whitespace-only strings)
  if (_.isString(value) && _.trim(value) === '') return true;

  // Check for empty arrays
  if (_.isArray(value) && value.length === 0) return true;

  // All other cases
  return false;
};

const mandatoryCheck = (type, value, mandatory) => isEmptyOrBlank(value) && mandatory;

const numberCheck = (type, value) =>
  (type === types.number)
  && !_.isEmpty(value)
  && (isNaN(parseFloat(value)) || !isFinite(value));

const minSelectionsCheck = (type, value, mandatory, question) => {
  if (question.minSelections && _.isArray(value)) {
    return value.length < question.minSelections;
  }
  return false;
};

const maxSelectionsCheck = (type, value, mandatory, question) => {
  if (question.maxSelections && _.isArray(value)) {
    return value.length > question.maxSelections;
  }
  return false;
};

const getMinSelectionsMessage = (question) => {
  const min = question.minSelections;
  return `Please select at least ${min} option${min > 1 ? 's' : ''}`;
};

const getMaxSelectionsMessage = (question) => {
  const max = question.maxSelections;
  return `Please select no more than ${max} option${max > 1 ? 's' : ''}`;
};

const checks = [
  [mandatoryCheck, i18n.t('fieldIsMandatory')],
  [numberCheck, i18n.t('mustBeNumeric')],
];

const runChecks = (type, value, mandatory, question) => {
  let result = _.reduce(checks,
    (result, check) => {
      return check[0](type, value, mandatory, question) ? _.union(result, [check[1]]) : result;
    }, []);

  // Check min/max selections for multiChoice questions
  if (minSelectionsCheck(type, value, mandatory, question)) {
    result = _.union(result, [getMinSelectionsMessage(question)]);
  }
  if (maxSelectionsCheck(type, value, mandatory, question)) {
    result = _.union(result, [getMaxSelectionsMessage(question)]);
  }

  return result;
};

export const validate = (question, answer) =>
  runChecks(question.questionType, answer, question.mandatory, question);
